import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (form.new_password.length < 8) { toast.error("Yeni şifre en az 8 karakter olmalı."); return; }
    if (form.new_password !== form.confirm) { toast.error("Şifreler eşleşmiyor."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Şifreniz güncellendi.");
      setOpen(false);
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <>
      <span onClick={() => setOpen(true)} data-testid="change-password-trigger">{trigger}</span>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#13131C] border-[#222230] text-white max-w-sm" data-testid="change-password-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-xl flex items-center gap-2"><KeyRound size={18} className="text-[#FF5500]" /> Şifre Değiştir</DialogTitle>
            <DialogDescription className="text-[#68687B]">Güvenliğin için mevcut şifreni doğrula.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3 py-1">
            <div><Label className="text-xs text-[#A0A0B2]">Mevcut Şifre</Label>
              <Input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="cp-current" className="bg-[#0E0E14] border-[#2D2D3F] text-white mt-1" /></div>
            <div><Label className="text-xs text-[#A0A0B2]">Yeni Şifre</Label>
              <Input type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="cp-new" className="bg-[#0E0E14] border-[#2D2D3F] text-white mt-1" /></div>
            <div><Label className="text-xs text-[#A0A0B2]">Yeni Şifre (Tekrar)</Label>
              <Input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="cp-confirm" className="bg-[#0E0E14] border-[#2D2D3F] text-white mt-1" /></div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)} className="text-[#A0A0B2]">Vazgeç</Button>
            <Button onClick={submit} disabled={saving} data-testid="cp-submit" className="bg-[#FF5500] hover:bg-[#FF661A] text-white font-bold">{saving ? <Loader2 className="animate-spin" size={16} /> : "Güncelle"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
